<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { orderLicenseLink } from '@@/const/externalLinks'

const { t } = useI18n()

const licenseDetails = useLicenseDetails()

const hasLicenses = computed(() => licenseDetails.data?.value && licenseDetails.data.value.length > 0)

const heading = computed(() => hasLicenses.value
  ? t('settings.yourActiveLicenses')
  : t('settings.noActiveLicenses'))

const tryNewProductsMessage = computed(() => hasLicenses.value
  ? t('settings.wantToTryMoreSubjects')
  : t('settings.wantToTryOurProducts'))
</script>

<template>
  <CommonTypography
    variant="h4"
    component="h2"
    style="margin: 0"
  >
    {{ heading }}
  </CommonTypography>
  <AppSettingsLicenseDetailsList
    v-if="licenseDetails.data?.value && hasLicenses"
    :license-details="licenseDetails.data.value"
    :aria-label="heading"
  />
  <div>
    <CommonTypography
      variant="body"
      style="margin: 0 0 16px;"
    >
      {{ tryNewProductsMessage }}
    </CommonTypography>
    <CommonButton :href="orderLicenseLink">
      <FontAwesomeIcon :icon="faArrowRight" />
      {{ $t('orderLicensePage.orderLicense') }}
    </CommonButton>
  </div>
</template>
